import { api } from "@/helper/api";
import { KAER_COMPANY_SUBJECT_ID } from "@/helper/systemIds";

export function getMainCategories(setOptions: any) {
  api.genericApiRequest({
    method: "get",
    entity: "mainCategory",
    successHandler: (res: any) => {
      const categoryOptions = res.data.results.map((item: any) => ({
        value: item.id,
        label: item.name,
      }));
      setOptions(categoryOptions);
    },
  });
}

export function getTrackedServiceType(setOptions: any) {
  api.genericApiRequest({
    method: "get",
    entity: "trackedServiceType",
    successHandler: (res: any) => {
      const typeOptions = res.data.results.map((item: any) => ({
        value: item.id,
        label: item.name,
      }));
      setOptions(typeOptions);
    },
  });
}

export function getTrackedServiceTemplate(setTemplateOptions: any) {
  api.genericApiRequest({
    method: "get",
    entity: "trackedServiceTemplate",
    getAllPages: true,
    successHandler: (res: any) => {
      const templateOptions = res.data.results.map((item: any) => ({
        value: item.id,
        label: item.name,
      }));

      setTemplateOptions(
        templateOptions.sort((a: any, b: any) =>
          a.label.localeCompare(b.label),
        ),
      );
    },
  });
}

export function getKaerEmployees(setOptions: any) {
  const additionalUserParameters: any = {};
  additionalUserParameters["impersonate_subject"] = KAER_COMPANY_SUBJECT_ID;
  additionalUserParameters["is_active"] = "true";
  additionalUserParameters["include_relations"] = true;

  api.genericApiRequest({
    entity: "user",
    method: "get",
    parametersToRender: {
      additionalUrlParameters: additionalUserParameters,
      depth: "0",
    },
    successHandler: (res: any) => {
      const employeeOptions = res.data.results.map((item: any) => ({
        value: item.person.subject,
        label: item.last_name + ", " + item.first_name,
      }));

      setOptions(
        employeeOptions.sort((a: any, b: any) =>
          a.label.localeCompare(b.label),
        ),
      );
    },
  });
}
